import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FilterByIdPipe } from './filter-by-id.pipe';
import { FilterBrandsPipe } from './filter-brands.pipe';
import { BrandSearchPipe } from './brand-search.pipe';
import { SanitizeHtmlPipe } from './sanitize-html.pipe';
import { ReplacePipe } from './replace.pipe';
import { PhonePipe } from './phone.pipe';
import { DateSuffixPipe } from './date-suffix.pipe';
import { FloorPipe } from './floor.pipe';
import { ReplacecommaPipe } from './replacecomma.pipe';
import { StoreBasedDatePipe } from './store-based-date.pipe';
import { LimitWordsPipe } from './word_limit.pipe';
import { MapUrlForImgPipe } from './map-url-for-img.pipe';

@NgModule({
    imports: [ 
        CommonModule 
    ],
    declarations: [
        FilterByIdPipe,
        FilterBrandsPipe,
        BrandSearchPipe,
        SanitizeHtmlPipe,
        LimitWordsPipe,
        ReplacePipe,
        PhonePipe,
        DateSuffixPipe,
        FloorPipe,
        ReplacecommaPipe,
        StoreBasedDatePipe,
        MapUrlForImgPipe
    ],
    exports: [
        FilterByIdPipe,
        FilterBrandsPipe,
        BrandSearchPipe,
        SanitizeHtmlPipe,
        LimitWordsPipe,
        ReplacePipe,
        PhonePipe,
        DateSuffixPipe,
        FloorPipe,
        ReplacecommaPipe,
        StoreBasedDatePipe,
        MapUrlForImgPipe
    ],
    providers: [
        PhonePipe
    ]
})
export class PipesModule { }
